<template>
  <div class="h-100">
    <div class="text-center col">
      <h5>
        {{ $t('BoardNotesBar.title') }}
      </h5>
    </div>

    <div v-if="this.loading" class="text-center">
      <BeatLoader v-if="this.loading" />
    </div>

    <div
      v-else-if="this.error"
      class="text-center"
    >
      {{ $t('BoardNotesBar.loadingError') }}
    </div>

    <div v-else id="notes-content">
      <div v-if="this.notes.length === 0">
        <p class="text-center p-3">
          <i class="fas fa-3x fa-file-circle-check text-success text-center" />
        </p>
        <p class="p-3">
          {{ $t('BoardNotesBar.niceDesign') }}
        </p>
      </div>
      <div
        v-if="this.notes.length > 0"
        class="analyze-notice"
      >
        <p class="text-center p-3">
          <i class="fas fa-3x fa-file-circle-exclamation text-secondary text-center" />
        </p>
        <p class="px-3">
          {{ $t('BoardNotesBar.notesDescription') }}
        </p>
      </div>

      <NotesAccordion
        :notes="notes"
        @note-click="drawNote"
      />
    </div>
  </div>
</template>

<script>
import { getRequest } from 'helper/request';
import messages from 'locales/BoardNotesBar';

import BeatLoader from 'components/shared/BeatLoader.vue';
import NotesAccordion from './NotesAccordion.vue';

export default {
  name: 'BoardNotesBar',
  components: { NotesAccordion, BeatLoader },
  props: {
    metaPath: String,
  },
  data() {
    return {
      notes: [],
      bus: this.$root.bus,
      loading: false,
      error: null,
    };
  },
  computed: {},
  methods: {
    loadMeta() {
      getRequest(this.metaPath).then((data) => {
        this.notes = data.notes.map((note) => {
          note.selected = false;
          return note;
        });
        this.loading = false;
      }).catch((e) => {
        this.loading = false;
        this.error = e;
      });
    },
    drawNote(note) {
      if (note.shapes.length <= 0) {
        return;
      }
      note.selected = !note.selected;
      const method = note.selected ? 'addNote' : 'removeNote';
      this.bus.emit(method, note);
    },
  },
  mounted() {
    this.loading = true;
    this.loadMeta();
  },
  unmounted() {
    this.accordion.destroy();
  },

  i18n: { messages },
};
</script>

<style scoped lang="scss">
</style>
